// Copyright (c) 2015, mobileX Neo
// MIT License. See license.txt

// provide a namespace
if(!window.neo)
	window.neo = {};

neo.provide = function(namespace) {
	// docs: create a namespace //
	var nsl = namespace.split('.');
	var parent = window;
	for(var i=0; i<nsl.length; i++) {
		var n = nsl[i];
		if(!parent[n]) {
			parent[n] = {}
		}
		parent = parent[n];
	}
	return parent;
}

neo.provide("locals");
neo.provide("neo.flags");
neo.provide("neo.settings");
neo.provide("neo.utils");
neo.provide("neo.ui.form");
neo.provide("neo.modules");
neo.provide("neo.templates");
neo.provide("neo.test_data");
neo.provide('neo.utils');
neo.provide('neo.model');
neo.provide('neo.user');
neo.provide('neo.session');
neo.provide("neo._messages");
neo.provide('locals.DocType');

// for listviews
neo.provide("neo.listview_settings");
neo.provide("neo.tour");
neo.provide("neo.listview_parent_route");

// constants
window.NEWLINE = '\n';
window.TAB = 9;
window.UP_ARROW = 38;
window.DOWN_ARROW = 40;

// proxy for user globals defined in desk.js

// API globals
window.cur_frm=null;
